// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 登录接口 POST /api/v1/authorize */
export async function authorize(body: API.AuthorizeParams, options?: { [key: string]: any }) {
  return request<API.AuthorizeResult>('/api/v1/authorize', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}



export async function refreshToken(body: API.RefreshTokenParams, options?: { [key: string]: any }) {
  return request<API.RefreshTokenResult>('/api/v1/token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}



export async function outLogin() {
  // 空实现，不执行任何操作

  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  return {};
}

/**新注册体系 */
// export async function register(body: API.AuthorizeParams, options?: { [key: string]: any }) {
//   return request<API.AuthorizeResult>('/api/v1/register', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: body,
//     ...(options || {}),
//   });
// }

/** 新登录体系 */
// export async function newLogin(body: API.AuthorizeParams, options?: { [key: string]: any }) {
//   return request<API.AuthorizeResult>('/api/v1/login', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: body,
//     ...(options || {}),
//   });
// }

